export enum eTaskStatus {
    ALL = 0,
    PENDING = 1,
    COMPLETED = 2,
    ARCHIVED = 3
}